import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

function WinningTip() {
  const [searchParams] = useSearchParams();
  const [imgError, setImgError] = useState(false);
  
  const horseNumber = searchParams.get('horseNumber') || '5';
  const horseName = searchParams.get('horseName') || 'CALDANTE';
  const trackName = searchParams.get('trackName') || 'Cairns';
  const raceNumber = searchParams.get('raceNumber') || '8';
  const screenshotUrl = searchParams.get('screenshotUrl') || '';

  // Update document title on component mount or when horseName changes
  useEffect(() => {
    document.title = `Lexi Tips - ${horseName} Winner`;
  }, [horseName]);

  // Handle image loading errors
  const handleImageError = () => {
    console.error('Failed to load screenshot image');
    setImgError(true);
  };

  return (
    <>
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;700;900&display=swap');
          
          body, html {
            margin: 0;
            padding: 0;
            width: 1080px;
            height: 1080px;
            font-family: 'Inter', sans-serif;
            background-color: #FCEDF7;
            overflow: hidden;
          }
          
          .instagram-post {
            position: relative;
            width: 1080px;
            height: 1080px;
            background: #FCEDF7;
            overflow: hidden;
          }
          
          .winner-announcement {
            position: absolute;
            width: 1080px;
            height: 115px;
            left: 0px;
            top: 275px;
            font-style: italic;
            font-weight: 900;
            font-size: 83px;
            line-height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            text-transform: uppercase;
            color: #F30099;
            z-index: 20;
          }
          
          .horse-details {
            position: absolute;
            width: 1080px;
            height: 87px;
            left: 0px;
            top: 429px;
            font-style: italic;
            font-weight: 900;
            font-size: 54px;
            line-height: 70px;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: bottom;
            text-transform: uppercase;
            color: #000000;
            z-index: 20;
          }
          
          .horse-number {
            margin-top: 12px;
            margin-right: 12px;
            font-size: 48px;
            vertical-align: bottom;
          }
          
          .track-info {
            position: absolute;
            width: 1080px;
            height: 42px;
            left: 0px;
            top: 531px;
            font-style: italic;
            font-weight: 700;
            font-size: 36px;
            line-height: 70px;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            text-transform: capitalize;
            color: #000000;
            z-index: 20;
          }
          
          .branding {
            position: absolute;
            width: 252px;
            height: 58px;
            left: 656px;
            top: 950px;
            z-index: 20;
          }
          
          /* Apple Template Styles */
          .apple-template-container {
            position: absolute;
            width: 620.72px;
            height: 1270.06px;
            left: 3.84px;
            top: 691px;
            transform: rotate(3.92deg);
            z-index: 5;
          }

          .apple-template-img {
            position: absolute;
            width: auto;
            height: auto;
            left: -38px;
            top: 40px;
            z-index: 5;
            pointer-events: none;
          }

          /* Adjusted position for the screenshot */
          .apple-screenshot {
            position: absolute;
            width: 564px;
            height: 429px;
            left: -10px;
            top: 152px;
            z-index: 15;
            overflow: hidden;
            border-top-left-radius: 30px;
            border-top-right-radius: 10px;
            transform-origin: top left;
          }
          
          .screenshot-img {
            width: 100%;
            height: auto;
            display: block;
          }
          
          .error-img {
            background-color: #e0e0e0;
          }
        `}
      </style>
      <div className="instagram-post">
        <h2 className="winner-announcement">ANOTHER WINNER!</h2>
        
        <h3 className="horse-details">
          <span className="horse-number">#{horseNumber}</span> {horseName.toUpperCase()}
        </h3>
        
        <p className="track-info">{trackName} R{raceNumber}</p>
        
        {/* Apple Template Container */}
        <div className="apple-template-container">
          {/* Phone template image */}
          <img 
            src="https://lexi.tips/images/apple_template.png"
            alt="Apple Template" 
            className="apple-template-img" 
            id="apple-template" 
            crossOrigin="anonymous"
          />
          
          {/* Screenshot image positioned on top with higher z-index */}
          <div className="apple-screenshot">
            <img
              src={screenshotUrl}
              alt="Lexi Tips Preview"
              className={`screenshot-img ${imgError ? 'error-img' : ''}`}
              onError={handleImageError}
              crossOrigin="anonymous"
            />
          </div>
        </div>
        
        <div className="branding">
          <img 
            src="https://lexi.tips/lexi-tips-logo.svg" 
            alt="Lexi.tips" 
            id="lexi-logo" 
            width="auto"
            height="auto"
            crossOrigin="anonymous"
          />
        </div>
      </div>
    </>
  );
}

export default WinningTip; 